import { Component, Input, OnChanges, OnInit, } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CandidateRefereeNotesModalComponent } from '../../../components/candidate-referee-notes-modal/candidate-referee-notes-modal.component';
import { OrganisationService } from 'src/app/services/organisation/organisation.service';
import { AlertBannerService, AlertType } from 'src/app/lib/alert-banner';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import { XrefApiKeyModalComponent } from '../../../components/xref-api-key-modal/xref-api-key-modal.component'
import { WarningModalService } from 'src/app/services/warning-modal/warning-modal.service';
import {
  ShareTrackExpiryReportModalComponent
} from "../../../components/share-track-expiry-report-modal/share-track-expiry-report-modal.component";
import {
  LockedFeatureModalComponent
} from "../../../components/locked-feature-modal/locked-feature-modal.component";
import {
  LetterOfEmploymentModalComponent
} from "../../../components/letter-of-employment-modal/letter-of-employment-modal.component";
import {ConstantsService} from "../../../services/constants/constants.service";
import { PlanService } from "../../../services/plan-status/plan-status.service";
@Component({
  selector: 'app-org-reference-settings',
  templateUrl: './org-reference-settings.component.pug',
  styleUrls: ['./org-reference-settings.component.scss'],
  standalone: false
})
export class OrgReferenceSettingsComponent implements OnInit, OnChanges {
  @Input() org;
  org_detail: any;
  bsModalRef!: BsModalRef
  managePermissions = {};
  roles = ['member', 'member (restricted)', 'billing'];
  apiKeyRoles = ['admin', 'owner'];
  defaultNotes = false;
  loaded = true;
  apiKey = false;
  hasSharePermission = false;
  upgradeText = $localize`Upgrade available`;
  expiryTime: any = '';
  expiryUnit: any = '';
  contactLink = ConstantsService.CONTACT_US;
  hasReferenceSettingsPermission = false;
  canUpdateXrefApiKey = false;
  isTrialUser = false;
  showLetterOfEmployment = false;
  letterOfEmploymentEnabled = false;
  enabledText = $localize`Enabled`;
  disabledText = $localize`Disabled`;

  constructor(
    public modalService: BsModalService,
    private organisationService: OrganisationService,
    private alertList: AlertBannerService,
    private permissions: PermissionsService,
    private modal: WarningModalService,
    private planService: PlanService,

  ) { }


  ngOnInit(): void {
    this.hasReferenceSettingsPermission = this.permissions.hasPermission('can_set_reference_settings');
    this.canUpdateXrefApiKey = this.permissions.hasPermission('can_set_update_reference_key');

    if (this.permissions.isFeatureActivated('ent-10781-signup-improvements')) {
      this.isTrialUser = this.planService.planState.is_non_cb_trial;
    }

    this.hasSharePermission = this.permissions.isOrgFeatureEnabled('share_track');
    if (this.hasSharePermission) {
      this.organisationService.getExpiryReportData().subscribe(res => {
        if (res) {
          this.expiryTime = res.token_expiry;
          this.expiryUnit = res.token_value;
        }
      })
    }

    this.showLetterOfEmployment = this.permissions.isFeatureActivated('REC-13933-employer-pdf');
    if (this.showLetterOfEmployment && this.hasReferenceSettingsPermission) {
      this.organisationService.getLetterOfEmployment().subscribe(res => {
        if (res) {
          this.letterOfEmploymentEnabled = !!res.letter_of_employment_enabled;
        }
      })
    }
  }
  ngOnChanges(): void {
    if (this.org !== undefined) {
      this.defaultNotes = !this.roles.includes(this.permissions.userRole);
      this.apiKey = this.apiKeyRoles.includes(this.permissions.userRole);
    }
  }

  showShareAndTrackExpiryReportModal() {
    this.loaded = false;
    if (!this.hasSharePermission) {
      this.loaded = true;
      if (this.isTrialUser) {
        this.bsModalRef = this.modalService.show(LockedFeatureModalComponent, {
          class: 'modal-dialog-centered'
        });
        return;
      }
      window.open(this.contactLink, "_blank");
      return;
    } else {
      this.organisationService.getExpiryReportData().subscribe(res => {
        const initialState = {
          'expiryTime': this.expiryTime,
          'expiryUnit': this.expiryUnit
        }
        if (res) {
          this.loaded = true;
          initialState['expiryTime'] = res['token_expiry'];
          initialState['expiryUnit'] = res['token_value'];
        }
         this.bsModalRef = this.modalService.show(ShareTrackExpiryReportModalComponent, Object.assign({}, { class: 'modal-dialog-centered share-track-modal', initialState }));
        this.bsModalRef.content.saveClick.subscribe(res => {
          const nextExpiryTime = res['token_expiry'];
          const nextExpiryUnit = res['token_value'];

        this.organisationService.postReportExpiryData(nextExpiryTime, nextExpiryUnit).subscribe(
    _ => {
          this.expiryTime = nextExpiryTime;
          this.expiryUnit = nextExpiryUnit;

          this.alertList.append([{
            type: AlertType.SUCCESS,
            message: $localize`Success! Changes have been saved.`,
            keepOnRouteChange: true
          }]);
      }, error => {
          this.alertList.append([{
            type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
      }]);
    }
  );
});

        });
    }
  }
  showLetterOfEmploymentModal() {
    const initialState = {
      'enabled': this.letterOfEmploymentEnabled
    };
    this.bsModalRef = this.modalService.show(LetterOfEmploymentModalComponent, Object.assign({}, { class: 'modal-dialog-centered', initialState }));
    this.bsModalRef.content.saveClick.subscribe((enabled: boolean) => {
      this.organisationService.updateLetterOfEmployment(enabled).subscribe(
        _ => {
          this.letterOfEmploymentEnabled = enabled;
          this.alertList.append([{
            type: AlertType.SUCCESS,
            message: $localize`Success! Changes have been saved.`,
            keepOnRouteChange: true
          }]);
        }, error => {
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
          }]);
        }
      );
    });
  }

  showCandidateRefereeModal() {
    let initialState = {};
    this.bsModalRef = this.modalService.show(CandidateRefereeNotesModalComponent, Object.assign({}, { class: 'modal-dialog-centered modal-lg', initialState }));
    this.bsModalRef.content.updateParent.subscribe(
      res => {
      }
    )
  }

  showXrefApiKeyMmodal() {
    this.organisationService.getXrefApiKey('xref_open_api').subscribe(res => {
      const initialState = {
        'xrefApiKey': '',
        'keyExist': false
      }
      if (res['api_key']) {
        initialState['xrefApiKey'] = res['api_key'];
        initialState['keyExist'] = true;
      }
      this.bsModalRef = this.modalService.show(XrefApiKeyModalComponent, Object.assign({}, {
        class: 'modal-dialog-centered modal-lg',
        initialState
      }));
      this.bsModalRef.content.deleteClick.subscribe(res => this.deleteXrefApiKey());
      this.bsModalRef.content.saveClick.subscribe(res => {
        this.organisationService.postXrefApiKey('xref_open_api', res['xrefApiKey']).subscribe(
            res => {
              this.alertList.append([{
                type: AlertType.SUCCESS,
                message: $localize`Success! Xref API key has been saved.`,
                keepOnRouteChange: true
              }])
            }, error => {
              this.alertList.append([{
                type: AlertType.DANGER,
                message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
                keepOnRouteChange: true
              }])
            }
          )
        });
      })
    }

  deprecatedShowXrefApiKeyMmodal() {
    this.organisationService.deprecatedGetXrefApiKey(this.org.uid, 'xref_open_api').subscribe(res => {
      const initialState = {
        'xrefApiKey': '',
        'keyExist': false
      }
      if (res['api_key']) {
        initialState['xrefApiKey'] = res['api_key'];
        initialState['keyExist'] = true;
      }
        this.bsModalRef = this.modalService.show(XrefApiKeyModalComponent, Object.assign({}, {
          class: 'modal-dialog-centered l-popup',
          initialState
        }));
      this.bsModalRef.content.deleteClick.subscribe(res => this.deleteXrefApiKey());
      this.bsModalRef.content.saveClick.subscribe(res => {
        this.organisationService.deprecatedPostXrefApiKey(this.org.uid, 'xref_open_api', res['xrefApiKey']).subscribe(
          res => {
            this.alertList.append([{
              type: AlertType.SUCCESS,
              message: $localize`Success! Xref API key has been saved.`,
              keepOnRouteChange: true
            }])
          }, error => {
            this.alertList.append([{
              type: AlertType.DANGER,
              message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
              keepOnRouteChange: true
            }])
          }
        )
      });
    })
  }

  deleteXrefApiKey() {
      this.modal.confirm(
        $localize`Delete Xref API key`,
        $localize`\nAre you sure you want to delete this API key?`,
        false,
        $localize`Cancel`,
        $localize`Delete`,
        false,
        true,
        'https://assets.xref.com/omni/shared/error_icon.svg',
        true, true).subscribe(
        res => {
          if (res) {
            this.organisationService.deleteXrefApiKey('xref_open_api').subscribe(
                res => {
                  this.alertList.append([{
                    type: AlertType.SUCCESS,
                    message: $localize`Success! Xref API key has been deleted.`,
                    keepOnRouteChange: true
                  }])
                }, error => {
                  this.alertList.append([{
                    type: AlertType.DANGER,
                    message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
                    keepOnRouteChange: true
                  }])
                }
              )
          }
          else {
            this.showXrefApiKeyMmodal();
          }
        }
      )
  }
}
